export { brandCodes, brandRegionCodes, regionCodes } from "./brandRegionConfig";

export const environment = process.env.NODE_ENV;
export const isProduction = process.env.NODE_ENV === "production";
export const isDevelopment = process.env.NODE_ENV === "development";
export const isBrowser = typeof window !== "undefined";
export const isSecureWindowContext =
  typeof window !== "undefined" && window.isSecureContext;
